import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_PATH_TO_BACKEND,
    withCredentials: true,
});

const DISK_IMAGE_HOSTS = [
    "drive.google.com",
    "disk.yandex.ru",
    "disk.yandex.com",
    "yadi.sk",
];

const getBackendUrl = (path) => {
    const baseUrl = api.defaults.baseURL || "";

    if (!baseUrl) {
        return path;
    }

    return `${baseUrl.replace(/\/$/, "")}${path}`;
};

export const getImageSrc = (imageUrl) => {
    try {
        const url = new URL(imageUrl);
        const host = url.hostname.toLowerCase();
        const shouldProxy = DISK_IMAGE_HOSTS.some((diskHost) => host === diskHost || host.endsWith(`.${diskHost}`));

        if (!shouldProxy) {
            return imageUrl;
        }

        return getBackendUrl(`/api/nomenclature-image/proxy?url=${encodeURIComponent(imageUrl)}`);
    } catch (error) {
        return imageUrl;
    }
};
